import { Component, Input, SimpleChanges, Inject, forwardRef } from '@angular/core';
import './numberWidgetNg2.html';

@Component({
    selector: 'number-widget-ng2',
    template: require('./numberWidgetNg2.html')
})

export class NumberWidgetComponentNg2 {
    @Input() benchmarkValue: number;
    @Input() value: number;
    @Input() valuesUnit: string;
    @Input() text1: string;
    @Input() showBenchmarkComparison: boolean = false;
    @Input() isNoGroupLoadedAndPristineFilters: boolean;
    differenceInPercentage: number;
    @Input() mini: boolean = false;
    @Input() icon: string;

    getValueLineHeight() {
        return this.mini == true ? '38px' : '60px';
    }

    getPercentageColor() {
        return this.differenceInPercentage == 0 ?  '#a2a2a2' : this.differenceInPercentage > 0 ? '#4fcfa1' : '#fd7b87';
    }

    getPercentageMarginTop() {
        return this.mini && !this.icon ?  '40px' : '0';
    }

    ngOnChanges() {
        this.differenceInPercentage = (this.value - this.benchmarkValue) / this.benchmarkValue * 100;
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/explore/widgets/numberWidgetNg2.ts
 **/